import {useTranslation} from "react-i18next";
import {useContext, useEffect, useRef, useState} from "react";
import NavBreadcrum from "components/NavBreadcrum";
// -
import {SwalAlertChoice, SwalAlertClass} from "core/swalClass";
import AuthContext from "context/AuthContext";
import TopBarActions from "components/TopBarActions";
import ButtonsActions from "views/utils/buttonsActions";
import axiApi from "ApiCaller";
import TableSensors from "./sensors/TableSensors";
import PreviewSensors from "./sensors/PreviewSensors";
import FormSensors from "./sensors/FormSensors";
import {DeviceSensors} from "site-apps/devices/DevicesModels";
import navs from "./navs";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import ConditionalRender from "components/ConditionalRender";
import ItemsModel from "core/itemsModel";
import OrderingModel from "components/ordering/OrderingModel";

const buttonsActions = new ButtonsActions();
const ViewProfilesSensors = () => {
    const {user} = useContext(AuthContext);
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tt} = useTranslation("tables");

    const title = _Tr("configuration.sensors");
    const bread = [
        {
            name: _Tr("labels.device-configuration"),
            url: "/device-configuration/",
            current: false,
        },
        {name: title, current: true},
    ];
    const AlertQuestion = new SwalAlertChoice({
        icon: "info",
        iconColor: "#DD6B55",
        confirmButtonColor: "#DD6B55",
        confirmButtonText: _Tf("labels.delete"),
        cancelButtonText: _Tf("labels.cancel"),
    });
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});

    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const orderingRef = useRef(new OrderingModel());

    const [isLoading, setIsLoading] = useState(false);
    const [item, setItem] = useState({...DeviceSensors});
    const [checkedAll, setCheckedAll] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [models, setModels] = useState([]);
    const [buttonsTB, setButtonsTB] = useState(buttonsActions);
    // data table
    const [itemsShown, setItemsShown] = useState([]);

    const headersTable = [
        {name: _Tt("common.name"), attr: 0, direction: "asc", active: true, default: true},
        {name: _Tt("deviceModes.model"), attr: 1, direction: "asc", active: false},
    ];

    useEffect(() => {
        const buttons = {...buttonsTB};
        buttons.title = title;
        if (user.is_admin) {
            buttons.add.active = true;
            buttons.add.onClick = onClickAdd;
            buttons.add.disabled = false;
            buttons.edit.active = true;
            buttons.edit.disabled = true;
            buttons.edit.onClick = onClickEdit;
            buttons.delete.active = true;
            buttons.delete.disabled = true;
            buttons.delete.onClick = onCLickDelete;
        }
        setButtonsTB(buttons);
        // -
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => {
            fetchSensors();
        };
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => fetchSensors();
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPreview;
        items.current.item = DeviceSensors;

        fetchGetSensors();
    }, []);

    filters.current.filter = () => {
        pagerModelRef.current.paging.page = 1;
        const buttons = {...buttonsTB};
        buttons.filter.applied = true;
        setButtonsTB(buttons);
        fetchSensors();
    };

    const fetchGetSensors = async () => {
        setIsLoading(true);
        axiApi
            .get("/api/devices/configs/sensors/")
            .then((resp) => {
                if (resp.data) {
                    items.current.showed = [...resp.data.items];
                    items.current.models = [...resp.data.models];
                    setItemsShown([...items.current.showed]);
                    setModels([...resp.data.models]);
                    if (resp.data.pager) {
                        pagerModelRef.current.paging.update(resp.data.pager);
                    }
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const fetchSensors = async () => {
        setIsLoading(true);
        axiApi
            .post("/api/devices/configs/sensors/", filters.current.chosen, {
                params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
            })
            .then((resp) => {
                if (resp.data) {
                    items.current.setShowed(resp.data.items);
                    setItemsShown([...resp.data.items]);
                    if (resp.data.pager) {
                        pagerModelRef.current.paging.update(resp.data.pager);
                    }
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    function onClickAdd() {
        setItem({...DeviceSensors});
        setShowForm(true);
        buttonsActions.title = title;
        buttonsActions.counter = items.current.all.length;
        setButtonsTB(buttonsActions);
    }

    function onCLickDelete() {
        AlertQuestion.fire("Atención", "Se borrarán el modo o los modos selecionados").then((quest) => {
            if (quest.isConfirmed) {
                deleteItems();
            }
        });
    }

    function deleteItems() {
        let itemsDelete = items.current.getChosenIds();

        axiApi
            .post(`/api/devices/configs/sensors/delete/`, {
                items: itemsDelete,
            })
            .then((r) => {
                if (r.data.status) {
                    items.current.showed = items.current.showed.filter((power) => !itemsDelete.includes(power.id));
                    items.current.all = items.current.all.filter((power) => !itemsDelete.includes(power.id));
                    setItemsShown([...items.current.showed]);
                    items.current.clearChosen();
                    Alert.success("Operación realizada con éxito", "Los registros seleccionados se han eliminado correctamente");
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            });
    }

    const onClickEdit = () => {
        if (items.current.chosen.length > 1) {
            return false;
        }

        let item_ = items.current.showed.find((item) => item.id === items.current.chosen[0]);
        setItem({...item_});
        setShowForm(true);
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" chosen={items.current.chosen} />
            <div className="row">
                <div className="col-md col-12">
                    <LoaderSpinner isLoading={isLoading}>
                        <TableSensors
                            items={items}
                            itemsShow={itemsShown}
                            buttonsTB={buttonsTB}
                            setButtonsTB={setButtonsTB}
                            checkAll={checkedAll}
                            setCheckAll={setCheckedAll}
                            orderingRef={orderingRef}
                        />
                    </LoaderSpinner>
                </div>
                <ConditionalRender condition={showPreview}>
                    <PreviewSensors show={showPreview} item={item} />
                </ConditionalRender>
                <ConditionalRender condition={showForm}>
                    <FormSensors
                        show={showForm}
                        setShow={setShowForm}
                        item={item}
                        models={models}
                        items={items}
                        setItemsShown={setItemsShown}
                    />
                </ConditionalRender>
            </div>
        </>
    );
};
export default ViewProfilesSensors;
